import { useCallback } from 'react';
import { unstable_useBlocker as useBlocker } from 'react-router-dom';

// simplified version of example at:
// https://gist.github.com/chaance/2f3c14ec2351a175024f62fd6ba64aa6#file-use-prompt-jsx
// see also https://github.com/remix-run/react-router/blob/aacc2b94088835d1247bdf3a3f883f74cc3570a0/docs/hooks/use-prompt.md
const usePrompt = (message, shouldBlock) => {
  useBlocker(
    useCallback(
      ({ currentLocation, nextLocation }) => {
        const pathnameChanged =
          nextLocation.pathname !== currentLocation.pathname;
        return pathnameChanged && shouldBlock
          ? // eslint-disable-next-line no-alert
            !window.confirm(message)
          : false;
      },
      [shouldBlock, message],
    ),
  );
};

export default usePrompt;
